import * as React from 'react';
import { connectHits } from 'react-instantsearch-dom';
import { AlgoliaAnalyticsHelpers, AlgoliaAnalyticsTypes } from '@grandvisionhq/analytics';
import { Text } from '@grandvisionhq/elements';

function ConnectedHits({ hits , indexName , title  }) {
    const handleClickAnalytics = React.useCallback((hit, index)=>{
        if (hit.__queryID) {
            AlgoliaAnalyticsHelpers.clickedObjectIdsAfterSearch({
                eventName: AlgoliaAnalyticsTypes.AlgoliaAnalyticsEvents.SearchSuggestionClicked,
                objectIds: hit.objectID,
                positions: index + 1,
                queryId: hit.__queryID,
                searchIndex: indexName
            });
        }
    }, [
        indexName
    ]);
    if (!hits.length) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Text, {
        className: "suggestions-hits__title",
        component: "div",
        variant: "body-head"
    }, title), /*#__PURE__*/ React.createElement("div", {
        className: "suggestions-hits__list"
    }, hits.map((hit, index)=>/*#__PURE__*/ React.createElement("a", {
            className: "suggestions-hits__item",
            key: hit.objectID,
            href: `?q=${hit.query}`,
            onClick: ()=>handleClickAnalytics(hit, index)
        }, hit.query)
    )));
}
var ConnectedHits$1 = connectHits(ConnectedHits);

export { ConnectedHits, ConnectedHits$1 as default };
//# sourceMappingURL=ConnectedHits.js.map
